<script lang="ts">
	import { renderMarkdown } from '../markdownInputUtils.ts'

	interface MarkdownPreviewProps {
		content: string
		pure?: boolean
		class?: string
	}

	let { content, class: className = '', pure }: MarkdownPreviewProps = $props()
</script>

<div class="preview-content {className}" class:preview-pure={pure}>
	{@html renderMarkdown(content)}
</div>

<style>
	.preview-content {
		@apply p-4 max-w-none min-h-fit overflow-y-auto;
		max-height: inherit;
	}

	.preview-content.preview-pure {
		@apply p-0 border-none;
	}

	.preview-content :global(h1) {
		@apply text-2xl font-bold mb-4 mt-6 first:mt-0 text-[#001626E5] border-b border-gray-200 pb-2;
	}

	.preview-content :global(h2) {
		@apply text-xl font-bold mb-3 mt-5 first:mt-0 text-[#001626E5];
	}

	.preview-content :global(h3) {
		@apply text-lg font-bold mb-2 mt-4 first:mt-0 text-[#001626E5];
	}

	.preview-content :global(p) {
		@apply mb-4 text-[#001D33] leading-relaxed;
	}

	.preview-content :global(code) {
		@apply bg-gray-100 px-2 py-1 rounded text-sm font-mono text-[#E4485B];
	}

	.preview-content :global(pre) {
		@apply bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto mb-4;
	}

	.preview-content :global(pre code) {
		@apply bg-transparent text-gray-100 p-0;
	}

	.preview-content :global(strong) {
		@apply font-bold text-[#001626E5];
	}

	.preview-content :global(em) {
		@apply italic;
	}

	.preview-content :global(del) {
		@apply line-through text-[#001D33B2] decoration-2;
	}

	.preview-content :global(ul) {
		@apply mb-4 pl-6;
	}

	.preview-content :global(ol) {
		@apply mb-4 pl-6 list-decimal;
	}

	.preview-content :global(ul li) {
		@apply mb-1 list-disc text-[#001D33];
	}

	.preview-content :global(ol li) {
		@apply mb-1 list-decimal text-[#001D33];
	}

	.preview-content :global(li) {
		@apply mb-1 text-[#001D33];
	}

	.preview-content :global(li p) {
		@apply mb-2 last:mb-0;
	}

	.preview-content :global(blockquote) {
		@apply border-l-4 border-brand pl-4 italic text-[#001D33B2] mb-4;
	}

	.preview-content :global(br) {
		display: none;
	}

	.preview-content :global(.blockquote-wrapper) {
		@apply my-4;
	}

	.preview-content :global(a) {
		@apply text-brand underline hover:text-brand/80 transition-colors;
	}

	.preview-content :global(hr) {
		@apply border-0 border-t border-gray-300 my-6;
	}

	.preview-content :global(img) {
		@apply max-w-lg rounded-lg shadow-sm border border-gray-200;
	}

	.preview-content :global(.table-wrapper) {
		@apply my-4 overflow-x-auto border border-gray-200;
	}

	.preview-content :global(.markdown-table) {
		@apply w-full border-collapse;
	}

	.preview-content :global(.markdown-table th) {
		@apply bg-gray-50 px-4 py-3 font-semibold text-[#001626E5] border-b-2 border-gray-200;
	}

	.preview-content :global(.markdown-table td) {
		@apply px-4 py-3 border-b border-gray-200 text-[#001D33];
	}

	.preview-content :global(.markdown-table tbody tr:last-child td) {
		@apply border-b-0;
	}
</style>
